import { makeStyles } from "@material-ui/core/styles";

export const privilegeStyles = makeStyles((theme) => ({
  headerText: {
    textAlign: "left",
    font: "normal normal normal 1.5vw Segoe-ui",
    marginBottom: 0,
    letterSpacing: "0px",
    color: " #707070",
    fontSize: 28,
    display: "block",
    textAlign: "center",
  },
  topGrid: {
    marginBottom: 20,
    display: "flex",
    alignItems: "center",
  },
  searchInput: {
    width: 400,
    borderRadius: 20,
    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  searchInputIcon: {
    cursor: "pointer",
  },
  badge: {
    backgroundColor: "#C52025",
    color: "#fff",
    fontWeight: "bold",
    position: "absolute",
    right: -10,
    top: -15,
  },
  filterBtn: {
    marginLeft: 20,
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
  filterCardDiv: {
    "@media (max-width: 600px)": {
      overflow: "scroll",
    },
  },
  filterCard: {
    boxShadow: " 10px 10px 10px #00000029 !important",
    border: " 1px solid #707070",
    borderRadius: "20px !important",
    width: 400,
    zIndex: 100,
    marginBottom: 20,
    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  filterCardGridContainer: {
    height: "100%",
  },
  filterCardGrid: {
    borderRight: "1px solid #0000004D",
    alignSelf: "center",
  },
  filterCardHeadText: {
    fontWeight: "bold",
    fontSize: 24,
  },
  filterCardSubHeadText: {
    fontSize: 24,
  },
  filterCardInput: {
    borderRadius: 10,
  },
  filterCardBtnGrid: {
    textAlign: "center",
    alignSelf: "center",
  },
  filterCardResetBtn: {
    color: "#305698",
    backgroundColor: "#fff",
    fontSize: 15,
    border: " 1px solid #305698",
    borderRadius: 10,
    width: 100,
    height: 35,
    textTransform: "capitalize",
    marginTop: "3%",
  },
  exportBtn: {
    backgroundColor: "#0a72ba",
    color: "#fff!important",
    fontSize: "0.875rem",
    fontWeight: "bold",
    cursor: "pointer",
    borderRadius: 10,
    width: 100,
    height: 40,
    border: "none",
    "&:hover": {
      backgroundColor: "#0a72ba",
    },
  },
  filterCardApplyBtn: {
    color: "#fff",
    backgroundColor: "#305698",
    fontSize: 15,
    border: " 1px solid #305698",
    borderRadius: 10,
    width: 100,
    height: 35,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#305698",
    },
    "&:disabled": {
      color: "#fff",
    },
  },
  tableDiv: {
    // marginTop: 20,
    overflowY: "auto",
    height: 400,
  },
  emptyDataText: {
    textAlign: "center",
    fontSize: 30,
    fontFamily: "segoe-ui",
    padding: "10%",
    opacity: "0.4",
  },
  viewMore: {
    textAlign: "center",
    color: "#2F7CBD",
    fontSize: 25,
    padding: 10,
    cursor: "pointer",
    fontWeight: "bold",
  },
  viewMoreEnd: {
    textAlign: "center",
    color: "#2F7CBD",
    fontSize: "1.125rem",
    padding: 10,
    fontWeight: "bold",
    marginBottom: 100,
  },
  ArrowBackOutlinedIcon: {
    fontSize: 34,
    margin: "10px 10px 10px 10px",
    cursor: "pointer",
    "@media (max-width: 768px)": {
      fontSize: 26,
      marginTop: "0.7rem",
    },
  },
  setUpPrevilege: {
    "@media (max-width: 768px)": {
      fontSize: 21,
      marginTop: "0.5rem",
    },
  },
  previlegeField: {
    color: "#707070",
    fontSize: 22,
    "@media (max-width: 768px)": {
      fontSize: 18,
    },
  },
  previlegeValue: {
    color: "#000000",
    fontSize: 25,
    "@media (max-width: 768px)": {
      fontSize: 19,
    },
  },
  okBtn: {
    color: "#fff",
    backgroundColor: "#305698",
    fontSize: 15,
    border: " 1px solid #305698",
    borderRadius: 5,
    padding: "5px 10px",
    cursor: "pointer",
    width: 50,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#305698",
    },
    "&:disabled": {
      color: "#fff",
    },
  },
  gridDiv: {
    padding: 5,
  },
  // Dialog
  dialogParentDiv: {
    padding: 25,
  },
  parentText: {
    fontSize: 25,
  },

  // Decline dialog

  padding: {
    padding: "20px 0px",
  },
  parentTextIcon: {
    color: "#faae30",
    fontSize: 30,
  },
  subParentText: {
    color: "#595959",
    fontSize: 20,
  },
  dialogInput: {
    width: "100%",
    margin: "20px 0px",
  },
  cancelBtn: {
    color: "#305698",
    backgroundColor: "#fff",
    border: "2px solid #305698",
    borderRadius: 10,
    fontSize: 20,
    textTransform: "capitalize",
  },
  proceedBtnGrid: {
    textAlign: "right",
  },
  proceedBtn: {
    color: "#fff",
    backgroundColor: "#305698",
    borderRadius: 10,
    fontSize: 20,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#305698",
    },
  },

  contractexport: {
    backgroundColor: "#0a72ba",
    color: "#fff!important",
    fontSize: "0.875rem",
    fontWeight: "bold",
    cursor: "pointer",
    borderRadius: 10,
    marginRight:30,
    width: 150,
    height: 40,
    border: "none",
    "&:hover": {
      backgroundColor: "#0a72ba",
    },
  },
}));
